import { Grid } from 'components/Grid';
import { ErrorMessage, Heading, Loading } from 'components/CommonComponents';
import { ColourPaletteComponent } from './components/ColourPaletteComponent';
import { useColourPalette } from 'hooks/useColourPalette';

export const ColourPalettePage = () => {
    const [colourPalette, setColourPalette] = useColourPalette();

    return (
        <Grid numberOfColumns={1}>
            <Heading>Colour Palette</Heading>
            {colourPalette?.loading && <Loading />}
            {colourPalette?.error && <ErrorMessage />}
            {colourPalette?.result && (
                <ColourPaletteComponent colourPalette={colourPalette} setColourPalette={setColourPalette} />
            )}
        </Grid>
    );
};
